import React, { useEffect, useMemo, useState } from "react";
import { Dialog } from "primereact/dialog";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { useDispatch, useSelector } from "react-redux";
import { Localize } from "../../app/lang/langs";
import { getTeams, getInActiveTeams, changeTeamActiveStatus, setInactiveTeams } from "../../components/teams/teamsSlice";

export default function InactiveTeamsModel(props) {

    const dispatch = useDispatch();
    const visible = props.visible;
    const inactiveTeams = useSelector(
        (state) => state.teams.inactiveTeams || []
    );
    const [globalFilter, setGlobalFilter] = useState("");
    const [activatingId, setActivatingId] = useState(null);

    useEffect(() => {
        if (visible) {
            dispatch(getInActiveTeams());
        }
    }, [visible, dispatch]);

    const handleClose = () => {
        props.setVisible(false);
        dispatch(setInactiveTeams([]));
        setGlobalFilter("");
        setActivatingId(null);
    };

    const activateTeam = async (idTeam) => {
        if (!idTeam) return;
        try {
            setActivatingId(idTeam);
            await dispatch(changeTeamActiveStatus({ id_team: idTeam, active: 1 }));
            dispatch(getInActiveTeams());
            dispatch(getTeams());
        } finally {
            setActivatingId(null);
        }
    };
    const tableHeader = useMemo(
        () => (
            <div className="flex items-center gap-2 justify-between w-full">
                <span className="p-input-icon-left">
                    <InputText
                        value={globalFilter}
                        onChange={(e) => setGlobalFilter(e.target.value)}
                        placeholder="Recherche..."
                    />
                </span>
            </div>
        ),
        [globalFilter]
    );
    const actionBody = (row) => (
        <Button
            label={activatingId === row.id ? "Réactivation..." : "Réactiver"}
            icon={activatingId === row.id ? "pi pi-spin pi-spinner" : "pi pi-check"}
            severity="success"
            size="small"
            onClick={() => activateTeam(row.id)}
            disabled={!!activatingId}
        />
    );

    return (
        <Dialog
            header="Inactive Teams"
            visible={visible}
            onHide={handleClose}
            draggable={false}
            style={{ width: "60vw", maxWidth: 900 }}
            modal
        >
            {inactiveTeams.length > 0 ? (
                <DataTable
                    value={inactiveTeams}
                    header={tableHeader}
                    paginator
                    rows={10}
                    rowsPerPageOptions={[10, 20, 50]}
                    removableSort
                    scrollable
                    sortMode="single"
                    globalFilter={globalFilter}
                    emptyMessage="No inactive teams found."
                >
                    <Column field="id" header="ID" style={{ width: "8rem" }} sortable />
                    <Column field="name" header={Localize("Nom")} sortable />
                    <Column
                        header="Actions"
                        body={actionBody}
                        style={{ width: "12rem", textAlign: "center" }}
                    />
                </DataTable>
            ) : (
                <p className="m-0">No inactive teams found.</p>
            )}
        </Dialog>
    );
}